/* eslint-disable no-param-reassign */

import Vapi from 'vuex-rest-api';

const admin = new Vapi({
  state: {
    fetcherAdminGlobalCounts: {
      // Custom Log Levels
      post: 0,
      channel: 0,
      post_ready: 0,
      channel_ready: 0,
      tag: 0,
      feed: 0,
      feedRule: 0,
      job: 0,
      jobItem: 0,
      list: 0,
      listItem: 0,
      network: 0,
      profile: 0,
    },
  },
})
  .get({
    action: 'getFetcherAdminGlobalCounts',
    path: () => '/api/fetcher/admin/globalCounts',
    property: 'fetcherAdminGlobalCounts',
  })
  .getStore();

const mutations = {
  updateFetcherGlobalCount: (state, payload) => {
    console.log(payload);
    state.fetcherAdminGlobalCounts[payload.model] = payload.count;
  },
  updateFetcherGlobalCounts: (state, payload) => {
    // console.log(payload);
    state.fetcherAdminGlobalCounts = payload;
  },
};

const actions = {
  updateFetcherGlobalCount({ commit }, payload) {
    commit('updateFetcherGlobalCount', payload);
  },
  updateFetcherGlobalCounts({ commit }, payload) {
    commit('updateFetcherGlobalCounts', payload);
  },
};

admin.mutations = Object.assign(admin.mutations, mutations);
admin.actions = Object.assign(admin.actions, actions);

export default admin;
